<template>
  <div>
    <b-sidebar
      id="tracking-by-delivery"
      ref="modal"
      header-class="headerModalToggle"
      right
      shadow
      size="l"
      width="90%"
      :title="$t('OrdersHistory')"
      no-close-on-esc
      @hidden="onCancelToggle"
    >
      <template #title>
        <strong style="color: #101828;">{{ $t('OrdersHistory') }}</strong>
      </template>
      <template
        v-slot:header-close
      >
        <button
          style="color: #98A2B3;padding-left: 0px; padding-right: 0px;height: 60px;"
          class="fa fa-close"
          @click="onCancelToggle"
        />
      </template>
      <div style="padding: 10px;">
        <div style="display:flex;gap:10px;align-items:center;justify-content: center;margin-top: 10px;margin-bottom:10px;">
          <h2 style="text-align:center;margin-bottom:0px;">
            {{ $t('Order') }} {{ orderUnique?.orderNumber }}, {{ $t('AcceptanceDate') }}: {{ acceptanceDate }}, {{ $t('Location') }}: {{ locationName?.locationName }}
          </h2>
          <b-tooltip
            target="save-icon"
            placement="top"
          >
            {{ $t('SaveOrder') }}
          </b-tooltip>
          <b-icon
            id="save-icon"
            icon="save"
            scale="1.5"
            style="cursor: pointer; color: green;"
            @click="stopScanningArticle"
          />
        </div>
        <div v-show="scanArticle">
          <video
            ref="video"
            style="width: 100%; height: auto"
          />
        </div>
        <button
          v-if="scanArticle"
          class="button"
          @click="removeScanner"
        >
          {{ $t('RemoveScanner') }}
        </button>
        <div style="display:flex;justify-content: space-between;align-items: end;">
          <button
            v-if="!scanArticle"
            class="button"
            :disabled="loadingScanned"
            @click="addScanner"
          >
            {{ $t('ScanArticle') }}
          </button>
          <button
            v-if="!scanArticle"
            v-b-modal.add-files-delivery-modal
            class="button"
          >
            {{ $t('AddFiles') }}
          </button>
        </div>
        <div
          v-if="loadingScanned"
          style="display:flex;gap:5px;margin-top: 10px;"
        >
          <div
            class="spinner-border spinner-border-sm"
          />
          <p style="font-weight:600;">
            {{ $t('AddingScannedProduct') }}
          </p>
        </div>
        <p style="font-weight:600;color:black;margin-top: 5px; margin-bottom: 0px;">
          {{ scannedArticle }}
        </p>
        <div style="display:flex;gap:5px">
          <p style="font-weight:600;color:black;margin-top: 5px; margin-bottom: 0px;">
            {{ textFromScanner }}
          </p>
          <button
            v-if="textFromScanner !== ''"
            v-b-modal.add-article-order-modal-editing
            class="button"
          >
            {{ $t('AddManually') }}
          </button>
        </div>
        <div>
          <table
            class="team_table"
            style="margin-top:10px;"
          >
            <thead>
              <tr>
                <th>
                  {{ $t('No') }}
                </th>
                <th>
                  {{ $t('ArticleNumber') }}
                </th>
                <th>
                  {{ $t('Barcode') }}
                </th>
                <th>
                  {{ $t('Quantity') }}
                </th>
                <th>
                  {{ $t('Edit') }}
                </th>
              </tr>
            </thead>
            <LoadingSpinnerTable
              :is-loading="isRequestLoading('loadDeliveryMinimalInfos')"
              :response-data="getDeliveryMinimalInfosArticle"
            >
              <tr
                v-for="(item, index) in articleList"
                :key="index"
              >
                <td>
                  {{ getDeliveryMinimalInfosArticleItems-(pageNumber-1) * pageSize-index }}.
                </td>
                <td>
                  {{ item.articleNumber }}
                </td>
                <td>
                  {{ item.barcode }}
                </td>
                <td>
                  {{ item.quantity }}
                </td>
                <td>
                  <b-icon-pencil
                    v-b-modal.edit-quantity-order-modal
                    style="cursor:pointer;"
                    @click="editNewQuantity(item)"
                  />
                </td>
              </tr>
            </LoadingSpinnerTable>
          </table>
          <div>
            <b-pagination
              v-if="getDeliveryMinimalInfosArticleItems > 15"
              v-model="pageNumber"
              :total-rows="getDeliveryMinimalInfosArticleItems"
              :per-page="pageSize"
              first-number
              last-number
              align="fill"
              prev-class="prev-itemi"
              next-class="next-itemi"
              class="mt-1 mb-0"
            >
              <template #prev-text>
                <span class="previousOrNext"><b-icon-arrow-left />{{ $t('Previous') }}</span>
              </template>
              <template #next-text>
                <span class="previousOrNext">{{ $t('Next') }}<b-icon-arrow-right /></span>
              </template>
            </b-pagination>
          </div>
        </div>
        <ArticlesOverviewEditing />
        <EditQuantityOrder
          :quantity="quantity"
          :product-name="productName"
          @editQuantity="editQuantityOrders"
        />
        <AddFilesDelivery
          :order-unique="orderUnique"
          @addFilesDeliveryModal="addFilesDeliveryManagement"
        />
      </div>
    </b-sidebar>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
// import moment from 'moment';
import { BrowserMultiFormatReader } from '@zxing/library';
import 'vue2-datepicker/index.css';
import Swal from 'sweetalert2';
import EditQuantityOrder from '@/components/productsInStock/modals/EditQuantityOrder.vue';
import AddFilesDelivery from '@/components/productsInStock/modals/AddFilesDelivery.vue';
import ArticlesOverviewEditing from '@/components/PurchaseArticles/ArticlesOverviewEditing.vue'

export default {
  components: {
    ArticlesOverviewEditing,
    EditQuantityOrder,
    AddFilesDelivery,
  },
  props: ['locationName', 'orderUnique', 'acceptanceDate'],
  data() {
    return {
      notes: null,
      textFromScanner: '',
      responseText: '',
      scannedArticle: '',
      loadingScanned: false,
      isScanning: true,
      scanArticle: false,
      codeReader: null,
      videoStream: null,
      pageNumber: 1,
      pageSize: 15,
      quantity: 0,
      productInStockId: null,
      productName: null,
    };
  },
  computed: {
    ...mapGetters([
      'getDeliveryMinimalInfosArticle',
      'getDeliveryMinimalInfosArticleItems',
      'getLocationByPagination',
    ]),
    articleList() {
      return this.getDeliveryMinimalInfosArticle.map((article) => {
        return {
          ...article,
          deliveryManagementId: this.orderUnique?.id,
        }
      });
    },
  },
  watch: {
    pageNumber(value) {
      if (value) {
        this.loadDeliveryMinimalInfos({
          pageNumber: value,
          pageSize: 15,
          deliveryManagementId: this.orderUnique?.id,
        })
      }
    },
  },
  mounted() {
  },
  methods: {
    ...mapActions([
      'loadArticleByScanner',
      'locationPagination',
      'startDeliveryGoods',
      'acceptArticleScanner',
      'loadDeliveryMinimalInfos',
      'editNewOrdersQuantity',
      'addFilesDelivery',
    ]),
    addFilesDeliveryManagement(value) {
      this.addFilesDelivery({
        object: value,
      })
    },
    editQuantityOrders(value) {
      const object = {
        quantity: value,
        deliveryManagementId: this.orderUnique?.id,
        productInStockId: this.productInStockId,
      }
      this.editNewOrdersQuantity({
        object,
        successCallback: () => {
          this.loadDeliveryMinimalInfos({
            pageNumber: this.pageNumber,
            pageSize: 15,
            deliveryManagementId: this.orderUnique?.id,
          })
        },
      })
    },
    editNewQuantity(value) {
      this.quantity = value.quantity;
      this.productInStockId = value.productInStockId
      this.productName = value.articleNumber
    },
    startScanningArticle() {
      const object = {
        receiverLocationId: this.locationName.locationId,
        notes: this.notes,
      }
      this.startDeliveryGoods({
        object,
      }).then((response) => {
        this.startScanningArticles = true;
        this.orderUnique = response
      })
    },
    stopScanningArticle() {
      this.scanArticle = false
      this.isScanning = true;
      this.scannedArticle = ''
      this.textFromScanner = '';
      this.stopScanner();
      Swal.fire({
        icon: 'success',
        title: `${this.$t('Order')} ${this.orderUnique?.orderNumber} ${this.$t('SavedSuccessF')}`,
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 1500,
      });
      this.onCancelToggle()
    },
    addScanner() {
      this.scanArticle = true;
      this.isScanning = false;
      this.scannedArticle = '';
      this.textFromScanner = '';
      this.startScanner();
      // const barcodes = ['123421', '42134213', '421342132', '2414213213', '123'];
      // const randomBarcode = barcodes[Math.floor(Math.random() * barcodes.length)];
      // this.searchByBarcodeScanner(randomBarcode);
    },
    removeScanner() {
      this.scanArticle = false
      this.isScanning = true;
      this.scannedArticle = ''
      this.textFromScanner = '';
      this.stopScanner();
    },
    startScanner() {
      const codeReader = new BrowserMultiFormatReader();
      this.codeReader = codeReader;
      const videoElement = this.$refs.video;

      // Continuously scan the video stream
      codeReader
        .decodeFromVideoDevice(null, videoElement, (result, err) => {
          if (result) {
            this.onDecode(result.getText());
          }
          if (err && err.name !== 'NotFoundException') {
            console.error(err);
          }
        });

      // Start camera stream
      navigator.mediaDevices
        .getUserMedia({
          video: { facingMode: { exact: 'environment' } },
        })
        .then((stream) => {
          this.videoStream = stream;
          videoElement.srcObject = stream;
        })
        .catch((error) => {
          console.error('Error accessing camera:', error);
        });
    },
    stopScanner() {
      if (this.codeReader) {
        this.codeReader.reset();
      }

      if (this.videoStream) {
        const tracks = this.videoStream.getTracks();
        tracks.forEach((track) => { return track.stop() });
      }
      this.videoStream = null;
    },
    onDecode(text) {
      if (this.isScanning) {
        return;
      }
      this.isScanning = true;

      this.searchByBarcodeScanner(text)
    },
    onLoaded() {
      console.log('Ready to start scanning barcodes')
    },
    async searchByBarcodeScanner(value) {
      this.scanArticle = false;
      this.loadingScanned = true
      this.loadArticleByScanner({
        barcode: value,
      }).then((response) => {
        this.responseText = response
        if (!response || (Object.keys(response).length === 0 && response.constructor === Object)) {
          this.textFromScanner = `${this.$t('ThisProductNotRegistered')}`
          this.scanArticle = false;
          this.loadingScanned = false
          this.stopScanner();
        } else {
          const object = {
            inventoryProductId: response.inventoryId,
            receiverLocationId: this.locationName.locationId,
            articleNumber: response.articleNumber,
            quantity: 1,
            deliveryManagementId: this.orderUnique?.id,
          }
          const duplicate = this.articleList.find((article) => {
            return article.inventoryProductId === response.inventoryId;
          });
          if (duplicate) {
            this.scannedArticle = `${this.$t('ArticleNumber')}: ${response.articleNumber}; ${this.$t('Barcode')}: ${value}`
            duplicate.quantity += 1;
            this.acceptArticleScanner({
              object,
              successCallback: () => {
                this.loadingScanned = false
                this.scanArticle = false;
                this.stopScanner();
              },
            })
            this.loadingScanned = false
            this.scanArticle = false;
            this.stopScanner();
            return;
          }
          this.acceptArticleScanner({
            object,
            successCallback: (productStock) => {
              this.getDeliveryMinimalInfosArticleItems += 1
              this.$store.commit('SET_DELIVERY_MINIMAL_INFOS_ARTICLE_ITEMS', this.getDeliveryMinimalInfosArticleItems + 1);
              if (this.articleList.length === 15) {
                this.articleList.splice(this.articleList.length - 1, 1);
              }
              this.articleList.unshift({
                articleNumber: `${response.articleNumber}`,
                barcode: `${value}`,
                inventoryProductId: response.inventoryId,
                quantity: 1,
                deliveryManagementId: this.orderUnique?.id,
                productInStockId: productStock,
              });
              this.scanArticle = false;
              this.loadingScanned = false
              this.scannedArticle = `${this.$t('ArticleNumber')}: ${response.articleNumber}; ${this.$t('Barcode')}: ${value}`
              this.stopScanner();
            },
          })
          this.loadingScanned = false
          this.stopScanner();
        }
      }).catch((error) => {
        console.error('Error scanning barcode:', error);
      });
    },
    onCancelToggle() {
      this.scanArticle = false
      this.isScanning = true;
      this.scannedArticle = ''
      this.textFromScanner = '';
      this.stopScanner();
      this.$emit('onCancelToggle');
      this.$refs.modal.hide();
    },
  },
};
</script>

    <style scoped lang="scss">

    .team_table td {
      padding: 16px 9px !important;
    }

    .team_table tr {
      border-bottom: 1px solid #dcdfe6;
      color: #606266;
    }

    .team_table thead {
      border-bottom: 1px solid #dcdfe6;
      color: #606266;
      text-align: left;
    }
    .hover-row:hover {
        background-color: rgba(255, 39, 79, 0.1);
    }
      .mats-listing__wrapper {
        width: 600px !important;

        .tt {
          .vgt-table {
            th.sortable button {
              display: none !important;
            }
          }
        }

        .mats-listing {
          margin-top: 0;
        }
      }



      .team_table {
        font-size: 12px;
        border-radius: 8px;
        width: 100%;
        box-shadow: none;
      }

      // .team_table .tr{
      //   border-radius: 10px 10px 10px 10px !important;
      // }


      @media screen and (max-width: 1723px) {
        .mats-listing__wrapper {
          width: 400px !important;

          div {
            button {
              width: auto;
              height: 36px;
            }

            input {
              width: 160px;
            }

          }

          .table__search-input {
            padding-left: 0px;
            margin-left: 0px !important;
          }
        }

      }

      @media screen and (max-width: 1400px) {
        .mats-listing__wrapper {
          width: 100% !important;
        }
      }


      .dropdrop::-webkit-scrollbar {
        display: none;

      }

      .dropdrop {
        display: inline-block;
        overflow: auto;
        position: absolute;
        background: white;
        width: 227px;
        box-shadow: none;
      }

      input[name="search-box"] {
        display: block;
        max-width: 500px;
        width: 95%;
        padding: 0.5rem 1rem;
        padding-left: 25px;
      }

      .black {
        position: relative;
      }

      .black input {
        border: none;
        box-shadow: none;
      }

      .search-item {
        padding: 5px;
        max-width: 500px;
        width: 100%;
        font-weight: 400;
        color: #82868c;
        font-size: 1rem;
        border-bottom: 1px solid #e8e8e8;
      }

      .search-item:last-child {
        border-bottom: none;
      }

      .search-item:hover {
        background: #82868c;
        color: white;
      }

      .search-item hr {
        color: lightgray;
        border-top: none;
        margin: -1.3rem 0 0.5rem 0;
      }

      .is-active {
        background-color: #dedede;
      }
        </style>
